import { useEffect, useMemo } from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import type { ExperienceAttributes } from '@atlassian/jira-experience-tracker/src/common/types.tsx';

import { CONDITIONAL_FORMATTING_EXPERIENCE } from '../../common/constants.tsx';

const STABLE_EMPTY_OBJECT = {};

export function ExperienceFailure({
	error,
	attributes = STABLE_EMPTY_OBJECT,
}: {
	error: Error;
	attributes?: ExperienceAttributes;
}) {
	const onExperienceFailure = useExperienceFail({
		experience: CONDITIONAL_FORMATTING_EXPERIENCE,
		attributes,
	});

	useEffect(() => {
		onExperienceFailure(CONDITIONAL_FORMATTING_EXPERIENCE, error);
	}, [attributes, error, onExperienceFailure]);

	useMemo(() => {
		if (__SERVER__) {
			onExperienceFailure(CONDITIONAL_FORMATTING_EXPERIENCE, error);
		}
	}, [error, onExperienceFailure]);

	return null;
}
